import { gql } from '@apollo/client'

const BRAND_FIELDS = `
  brand {
    id
    name
    slug
    logo {
      url
    }
    squareLogo {
      url
    }
    primaryColorHex
    primaryTextColorHex
    appStyleConfig
  }
`

const SHOP_TAG_FIELDS = `
  shopTags {
    id
    name
    icon {
      url
    }
  }
`

const SHOP_IMAGES_FIELDS = `
  images {
    url
  }
`

const SHOP_FIELDS = `
  id
  slug
  name
  customerName
  phone
  address
  geo_delivery_zone
  shopGeoPoint {
    latitude
    longitude
  }
  status
  min_price
  minOrderCost
  open_time
  close_time
  isPickupDeliveryAvailable
  shopPickupDeliveryCost
  tzOffset
  brand_id
  ${BRAND_FIELDS}
  ${SHOP_TAG_FIELDS}
  ${SHOP_IMAGES_FIELDS}
`

const FIRST_AVAILABLE_SLOT_FIELDS = `
  firstAvailableSlot {
    id
    slotTime
    slotDate
    period {
      from
      to
    }
    availableUntil
    zone_id
    shop_id
  }
`

export const DELIVERY_ZONE_FIELDS = `
  id
  name
  status
  shop_id
  shop {
    ${SHOP_FIELDS}
  }
  zoneGeoDeliveryZone {
    latitude
    longitude
  }
  min_price
  minOrderCost
  delivery_cost
  first_delivery_cost
  freeSlotDeliveryCostFrom
  
  zoneExpressMaxWeight
  zoneTsExpressDeliveryStart
  zoneTsExpressDeliveryFinish
  zoneExpressDeliveryCost
  expressDeliveryMaxShippingTime
  isExpressDeliveryAvailable
  freeExpressDeliveryCostFrom
  
  zoneSlotMaxWeight
  ${FIRST_AVAILABLE_SLOT_FIELDS}
  tzOffset
`

export const GQL_ZONES_FOR_GEO_POINT = gql`
  query ZonesForGeoPoint($point: GeoPointInput!, $customerType: String) {
    zonesForGeoPoint(point: $point, customerType: $customerType) {
      ${DELIVERY_ZONE_FIELDS}
    }
  }
`

export const GQL_SINGLE_DELIVERY_ZONE = gql`
  query SingleDeliveryZone($id: ID!) {
    singleDeliveryZone(id: $id) {
      ${DELIVERY_ZONE_FIELDS}
    }
  }
`

export const GQL_ZONES_IN_GEO_POLYGON = gql`
  query ZonesInGeoPolygon($corners: [GeoPointInput]!, $customerType: String) {
    zonesInGeoPolygon(corners: $corners, customerType: $customerType) {
      ${DELIVERY_ZONE_FIELDS}
    }
  }
`

export const GQL_CHECK_ZONE_AVAILABLE = gql`
  query CheckIsZoneAvailableForGeoPoint($point: GeoPointInput!) {
    checkIsZoneAvailableForGeoPoint(point: $point)
  }
`
